import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  LuLayoutDashboard, LuHistory, LuWallet, LuArrowLeftRight,
  LuArrowUpRight, LuReceipt, LuNetwork, LuUsers,
  LuCalendar, LuTrophy, LuCrown, LuMedal, LuBriefcase, LuLogOut,
  LuX, LuChevronDown, LuPackage, LuShieldCheck
} from "react-icons/lu";
import { MdOutlineSupportAgent } from "react-icons/md";
import "./Header.css";

export default function Header() {

  const username = localStorage.getItem("username");
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = async () => {
    setIsLoggingOut(true);
    try {
      await axios.post(
        process.env.REACT_APP_BACKEND_LINK,
        {
          method: "user",
          submethod: "logoutu",
          username,
          key: process.env.REACT_APP_KEY,
        },{
          withCredentials: true
        }
      );
      // console.log('res logout',res);

      // Keep first-time feature tour flags across logout
      const preserved = {};
      for (let i = 0; i < localStorage.length; i += 1) {
        const key = localStorage.key(i);
        if (key && key.includes("_tour_seen_")) {
          preserved[key] = localStorage.getItem(key);
        }
      }

      // Clear frontend storage
      localStorage.clear();
      Object.entries(preserved).forEach(([key, value]) => {
        if (value != null) localStorage.setItem(key, value);
      });

      // Redirect
      window.location.replace("/");
      // navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
      setIsLoggingOut(false);
    }
  };



  const [show, setShow] = useState(false);
  const [isIncomeOpen, setIsIncomeOpen] = useState(false);
  const [isDepositOpen, setIsDepositOpen] = useState(false);
  const [isPurchaseOpen, setIsPurchaseOpen] = useState(false);
  const [isWithdrawalOpen, setIsWithdrawalOpen] = useState(false);
  const handleClickShowMenu = () => {
    setShow(true)

    // console.log("click");
  }
  const handleClickShowClose = () => {
    setShow(false)

    // console.log("click");
  }
  const currentPath = window.location.pathname;


  return (
    <>
      
      {/* Full Screen Logout Loader */}
      {isLoggingOut && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(15, 23, 42, 0.8)',
          backdropFilter: 'blur(4px)',
          webkitBackdropFilter: 'blur(4px)',
          zIndex: 10000,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'fadeIn 0.3s ease'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '24px'
          }}>
            {/* Spinner */}
            <div style={{
              width: '60px',
              height: '60px',
              border: '4px solid rgba(59, 130, 246, 0.2)',
              borderTop: '4px solid #3b82f6',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            
            {/* Text */}
            <div style={{
              color: '#ffffff',
              fontSize: '18px',
              fontWeight: '600',
              textAlign: 'center',
              letterSpacing: '0.5px'
            }}>
              Signing Out...
            </div>
            
            {/* Subtext */}
            <div style={{
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: '14px',
              textAlign: 'center'
            }}>
              Please wait while we process your request
            </div>
          </div>
        </div>
      )}
      
      {/* Mobile Overlay */}
      <div
        className={`mobile-overlay d-xl-none ${show ? 'active' : ''}`}
        onClick={handleClickShowClose}
      ></div>
      {/* Invisible placeholder to reserve space for the fixed sidebar on desktop */}
      <div className="d-none d-xl-block" style={{ width: '290px', flexShrink: 0 }}></div>
      <div className={show ? "nftmax-smenu nftmax-close" : "nftmax-smenu"}>
        <div className="admin-menu">
          <div className="pro-sidebar">
            <div className="pro-sidebar-header">
              <Link to="/">
                <img
                  className="nftmax-logo__main"
                  src="/assets/logo_dark.svg"
                  alt="GetLink Logo"
                  width={150}
                />
              </Link>
              <div
                className="d-xl-none"
                onClick={handleClickShowClose}
                style={{ cursor: 'pointer', padding: '12px', background: '#f8fafc', borderRadius: '10px', color: '#64748b' }}
              >
                <LuX size={24} />
              </div>
            </div>

            <div className="pro-sidebar-menu pt-0">
              <div className="pro-menu-category">Main Menu</div>

              <Link to="/dashboard" className={`pro-menu-item ${currentPath === "/dashboard" ? "active" : ""}`}>
                <span className="pro-menu-icon icon-cyan">
                  <LuLayoutDashboard />
                </span>
                <span className="pro-menu-label">Dashboard</span>
              </Link>

              <div className="pro-dropdown-container">
                <button
                  className={`pro-menu-item pro-menu-item-dropdown ${(currentPath === "/deposit" || currentPath === "/deposithistory") ? "active" : ""}`}
                  onClick={() => setIsDepositOpen(!isDepositOpen)}
                >
                  <span className="pro-menu-icon icon-green">
                    <LuWallet />
                  </span>
                  <span className="pro-menu-label">Add Funds</span>
                  <LuChevronDown className={`pro-chevron ${isDepositOpen ? "rotate" : ""}`} size={20} />
                </button>

                <div className={`pro-submenu my-2 ${isDepositOpen ? "open" : "closed"}`}>
                  <Link to="/deposit" className={`pro-menu-item ${currentPath === "/deposit" ? "active" : ""}`} style={{ marginBottom: '8px' }}>
                    <span className="pro-menu-icon icon-cyan">
                      <LuWallet />
                    </span>
                    <span className="pro-menu-label">Deposit</span>
                  </Link>

                  <Link to="/deposithistory" className={`pro-menu-item my-2  ${currentPath === "/deposithistory" ? "active" : ""}`} style={{ marginBottom: '0' }}>
                    <span className="pro-menu-icon icon-green">
                      <LuHistory />
                    </span>
                    <span className="pro-menu-label">Deposit History</span>
                  </Link>
                </div>
              </div>

              <div className="pro-dropdown-container">
                <button
                  className={`pro-menu-item pro-menu-item-dropdown ${(currentPath === "/stake" || currentPath === "/staking") ? "active" : ""}`}
                  onClick={() => setIsPurchaseOpen(!isPurchaseOpen)}
                >
                  <span className="pro-menu-icon icon-pink">
                    <LuPackage />
                  </span>
                  <span className="pro-menu-label">Purchase</span>
                  <LuChevronDown className={`pro-chevron ${isPurchaseOpen ? "rotate" : ""}`} size={20} />
                </button>

                <div className={`pro-submenu my-2 ${isPurchaseOpen ? "open" : "closed"}`}>
                  <Link to="/stake" className={`pro-menu-item ${currentPath === "/stake" ? "active" : ""}`} style={{ marginBottom: '8px' }}>
                    <span className="pro-menu-icon icon-cyan">
                      <LuShieldCheck />
                    </span>
                    <span className="pro-menu-label">Package</span>
                  </Link>

                  <Link to="/staking" className={`pro-menu-item my-2 ${currentPath === "/staking" ? "active" : ""}`} style={{ marginBottom: '0' }}>
                    <span className="pro-menu-icon icon-pink">
                      <LuHistory />
                    </span>
                    <span className="pro-menu-label">Purchase History</span>
                  </Link>
                </div>
              </div>


              <Link to="/tree" className={`pro-menu-item ${currentPath === "/tree" ? "active" : ""}`}>
                <span className="pro-menu-icon icon-cyan">
                  <LuNetwork />
                </span>
                <span className="pro-menu-label">Tree</span>
              </Link>

              <div className="pro-dropdown-container">
                <button
                  className={`pro-menu-item pro-menu-item-dropdown ${(currentPath === "/refferal" || currentPath === "/weeklyincome" || currentPath === "/level-income" || currentPath === "/primeincome" || currentPath === "/rankinc") ? "active" : ""}`}
                  onClick={() => setIsIncomeOpen(!isIncomeOpen)}
                >
                  <span className="pro-menu-icon icon-yellow">
                    <LuMedal />
                  </span>
                  <span className="pro-menu-label">Income & Rewards</span>
                  <LuChevronDown className={`pro-chevron ${isIncomeOpen ? "rotate" : ""}`} size={20} />
                </button>

                <div className={`pro-submenu my-2 ${isIncomeOpen ? "open" : "closed"}`}>
                  <Link to="/refferal" className={`pro-menu-item ${currentPath === "/refferal" ? "active" : ""}`} style={{ marginBottom: '8px' }}>
                    <span className="pro-menu-icon icon-blue">
                      <LuUsers />
                    </span>
                    <span className="pro-menu-label">Team Reward</span>
                  </Link>

                  <Link to="/weeklyincome" className={`pro-menu-item my-3 ${currentPath === "/weeklyincome" ? "active" : ""}`} style={{ marginBottom: '8px' }}>
                    <span className="pro-menu-icon icon-yellow">
                      <LuCalendar />
                    </span>
                    <span className="pro-menu-label">Weekly Reward</span>
                  </Link>

                  <Link to="/level-income" className={`pro-menu-item my-3 ${currentPath === "/level-income" ? "active" : ""}`} style={{ marginBottom: '8px' }}>
                    <span className="pro-menu-icon icon-red">
                      <LuTrophy />
                    </span>
                    <span className="pro-menu-label">Level Reward</span>
                  </Link>

                  <Link to="/primeincome" className={`pro-menu-item my-3 ${currentPath === "/primeincome" ? "active" : ""}`} style={{ marginBottom: '8px' }}>
                    <span className="pro-menu-icon icon-purple">
                      <LuCrown />
                    </span>
                    <span className="pro-menu-label">Prime Reward</span>
                  </Link>

                  <Link to="/rankinc" className={`pro-menu-item my-3 ${currentPath === "/rankinc" ? "active" : ""}`} style={{ marginBottom: '0' }}>
                    <span className="pro-menu-icon icon-green">
                      <LuMedal />
                    </span>
                    <span className="pro-menu-label">Rank Reward</span>
                  </Link>
                </div>
              </div>
              <div className="pro-dropdown-container">
                <button
                  className={`pro-menu-item pro-menu-item-dropdown ${(currentPath === "/wtihdrawal" || currentPath === "/wtihdrawalhistory" || currentPath === "/transfer" || currentPath === "/withdrwalAdress") ? "active" : ""}`}
                  onClick={() => setIsWithdrawalOpen(!isWithdrawalOpen)}
                >
                  <span className="pro-menu-icon icon-orange">
                    <LuArrowUpRight />
                  </span>
                  <span className="pro-menu-label">Withdrawal</span>
                  <LuChevronDown className={`pro-chevron ${isWithdrawalOpen ? "rotate" : ""}`} size={20} />
                </button>

                <div className={`pro-submenu my-2 ${isWithdrawalOpen ? "open" : "closed"}`}>
                  <Link to="/wtihdrawal" className={`pro-menu-item ${currentPath === "/wtihdrawal" ? "active" : ""}`} style={{ marginBottom: '8px' }}>
                    <span className="pro-menu-icon icon-orange">
                      <LuArrowUpRight />
                    </span>
                    <span className="pro-menu-label">Withdrawal request</span>
                  </Link>

                  <Link to="/wtihdrawalhistory" className={`pro-menu-item my-2 ${currentPath === "/wtihdrawalhistory" ? "active" : ""}`} style={{ marginBottom: '8px' }}>
                    <span className="pro-menu-icon icon-purple">
                      <LuReceipt />
                    </span>
                    <span className="pro-menu-label">Withdrawal History</span>
                  </Link>

                  <Link to="/transfer" className={`pro-menu-item my-2 ${currentPath === "/transfer" ? "active" : ""}`} style={{ marginBottom: '0' }}>
                    <span className="pro-menu-icon icon-blue">
                      <LuArrowLeftRight />
                    </span>
                    <span className="pro-menu-label">Transfer</span>
                  </Link>
                  <Link to="/withdrwalAdress" className={`pro-menu-item my-2 ${currentPath === "/withdrwalAdress" ? "active" : ""}`} style={{ marginBottom: '0' }}>
                    <span className="pro-menu-icon icon-blue">
                      <LuWallet />
                    </span>
                    <span className="pro-menu-label">Withdrawal Address</span>
                  </Link>
                </div>
                <Link to="/support" className={`pro-menu-item ${currentPath === "/support" ? "active" : ""}`}>
                  <span className="pro-menu-icon icon-cyan">
                    <MdOutlineSupportAgent />
                  </span>
                  <span className="pro-menu-label">Support</span>
                </Link>
              </div>

            </div>

            <div className="pro-sidebar-footer">
              <div style={{ marginBottom: '16px' }}>
                <Link to="/profile" className={`pro-menu-item ${currentPath === "/profile" ? "active" : ""}`}>
                  <span className="pro-menu-icon icon-blue">
                    <LuBriefcase />
                  </span>
                  <span className="pro-menu-label">Portfolio</span>
                </Link>
              </div>

              <button 
                className="pro-btn-logout" 
                onClick={logout}
                disabled={isLoggingOut}
                style={{
                  opacity: isLoggingOut ? 0.7 : 1,
                  cursor: isLoggingOut ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoggingOut ? (
                  <>
                    <span className="spinner-border spinner-border-sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }}></span>
                    <span>Signing Out...</span>
                  </>
                ) : (
                  <>
                    <LuLogOut size={18} />
                    <span>Sign Out</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <header className={show ? "ai-header nftmax-close" : "ai-header"}>
        <div className="container">
          <div className="d-flex align-items-center justify-content-between">

            {/* Left: Toggle & Search */}
            <div className="d-flex align-items-center gap-4">
              <div className="d-xl-none" onClick={handleClickShowMenu} style={{ cursor: 'pointer', padding: '10px', background: '#f1f5f9', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <img src="/assets/img/menu-toggle.svg" alt="#" style={{ width: '20px', height: '20px' }} />
              </div>
            </div>

            {/* Right: Actions */}
            <div className="d-flex align-items-center gap-3">

              {/* Balance Pill */}
              {/* <div className="ai-balance-pill">
                <i className="fa fa-wallet"></i>
                <span>${DBbalance || "0.00"}</span>
              </div> */}

              {/* User Profile (Info Only) */}
              {/* <div className="ai-user-pill">
                <div className="ai-user-info-text d-none d-sm-block text-end">
                  <div className="ai-user-name">GetLink</div>
                  <div className="ai-user-role">User</div>
                </div>
                <img src="logo-70.png" className="ai-avatar-small" alt="User" />
              </div> */}

              {/* Dedicated Logout Button */}
              <button
                onClick={logout}
                disabled={isLoggingOut}
                className="d-flex align-items-center justify-content-center"
                style={{
                  background: isLoggingOut ? 'rgba(59, 130, 246, 0.15)' : 'rgba(239, 68, 68, 0.1)',
                  border: isLoggingOut ? '1px solid rgba(59, 130, 246, 0.3)' : '1px solid rgba(239, 68, 68, 0.2)',
                  color: isLoggingOut ? '#3b82f6' : '#ef4444',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  cursor: isLoggingOut ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s',
                  opacity: isLoggingOut ? 0.8 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                title={isLoggingOut ? "Signing out..." : "Sign Out"}
              >
                {isLoggingOut ? (
                  <span 
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid rgba(59, 130, 246, 0.3)',
                      borderTop: '2px solid #3b82f6',
                      borderRadius: '50%',
                      animation: 'spin 0.8s linear infinite'
                    }}
                  ></span>
                ) : (
                  <img
                    src="/assets/img/logout.png"
                    alt="Logout"
                    style={{ width: '18px', height: '18px', filter: 'hue-rotate(320deg) brightness(0.9)' }}
                  />
                )}
              </button>

            </div>

          </div>
        </div>
      </header>
    </>
  );
}
